import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper'
import React, { useState } from 'react'
import { COMFORTABLE_SWIPER_INFO } from 'assets/json/scooterInfo.js'
// Import Swiper styles start
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/scrollbar'
// Import Swiper styles end

/**
 * @file 스마트스쿠터 화면에서 상단의 스쿠터 타입 영역의 swiper
 */
function ScooterEvC1SwiperTwo() {
    const [hoveredPcIdx, setHoveredPcIdx] = useState(-1) //mouseHover 되고있는 이미지의 index
    const settings = {
        className: 'evc1_comfortable_swiper',
        direction: 'horizontal',
        slidesPerView: 'auto', // 한 화면에 보이는 슬라이드 수
        spaceBetween: 0, // px 단위 간격
        loop: false,
        modules: [Navigation],
        navigation: {
            // 네비게이션 적용, < >
            nextEl: '.evc1_four_swiper_btn.next', // 다음 버튼 클래스명
            prevEl: '.evc1_four_swiper_btn.prev', // 이전 버튼 클래스명
        },
        breakpoints: {
            820: {
                slidesPerView: 'auto',
                spaceBetween: 0,
                //centeredSlides: true, // 중앙에 슬라이드를 맞춤
                //initialSlide: 1, // 두 번째 슬라이드를 초기 슬라이드로 설정
            },
        },
    }

    const handleMouseOverPc = (e, i) => {
        //e.stopPropagation()
        setHoveredPcIdx(i)
    }

    const handleMouseLeavePC = e => {
        //e.stopPropagation()
        setHoveredPcIdx(-1)
    }

    return (
        <Swiper {...settings}>
            <div className="swiper-wrapper">
                {COMFORTABLE_SWIPER_INFO.map((val, i) => (
                    <SwiperSlide
                        className="swiper-slide"
                        key={'scooter-viva-img-desc-swiper-slide-' + i}
                        onMouseOver={e => handleMouseOverPc(e, i)}
                        onMouseLeave={e => handleMouseLeavePC(e)}>
                        <img
                            className="img-box pc"
                            src={hoveredPcIdx === i ? val.imgUrlPcHover : val.imgUrlPc}
                            alt=""
                        />
                        <img className="img-box pad" src={val.imgUrlPad} alt="" />
                        <img className="img-box mobile" src={val.imgMoUrl} alt="" />
                        <div className="text-box">
                            <div className="t1_wrap">
                                <div className="number1">{val.numbering}</div>
                                <div className="t1">{val.title}</div>
                            </div>
                            <div className="desc pc_pad" dangerouslySetInnerHTML={{ __html: val.desc }}></div>
                            <div className="desc mobile" dangerouslySetInnerHTML={{ __html: val.descMobile }}></div>
                        </div>
                    </SwiperSlide>
                ))}
            </div>
        </Swiper>
    )
}

export default ScooterEvC1SwiperTwo
